'use client';

import { createContext } from 'react';

import { PortalUser } from '@ravago/shared/page-data/models/elements';

export interface PortalUsersContextProps {
   portalUsers: PortalUser[];
   setPortalUsers: (users: PortalUser[]) => void;
}

export const PortalUsersContext = createContext<PortalUsersContextProps | null>({ portalUsers: [], setPortalUsers: () => null });
